import React from 'react';
import { Chip, ChipProps } from '@mui/material';
// CONSTANTS
import { TP_COLORS } from '../../constants';

const defaultChipStyles: React.CSSProperties = {
  background: TP_COLORS.white,
  borderRadius: '4px',
  color: TP_COLORS.black,
  fontWeight: 600,
};

const SubjectCodeCard: React.FC<ChipProps> = ({ style, ...props }) => {
  return (
    <Chip
      {...props}
      style={style ? { ...defaultChipStyles, ...style } : defaultChipStyles}
    />
  );
};

export default SubjectCodeCard;
